import React from 'react';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./pages/Home";
import About from './pages/About';
import Education from './pages/Education';
import Work from './pages/Work';
import Contact from './pages/Contact';
import Project from './pages/Project';
import GitHubRepositories from './pages/GitHubRepositories';


function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Education" element={<Education />} />
        <Route path="/Work" element={<Work />} />
        <Route path="/Project" element={<Project />} />
        <Route path="/GitHubRepositories" element={<GitHubRepositories />} />
        <Route path="/Contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
